module.exports = __webpack_public_path__ + "img/图片6.8c4011b8.png";